import { useUsuario } from '../hooks/useUsuario'
import { clientesFeria, clientesRedes, participacionExtra } from '../modelos/cliente'
import { TEMPORADA } from '../utilidades/constants'

export function Grid({ fromRedes = false, className = '' }) {
    const { usuario } = useUsuario()
    const totalParticipaciones = fromRedes ? clientesRedes.length : clientesFeria.length + 1
    const numParticipaciones = fromRedes
        ? usuario?.numParticipacionesRedes || 0
        : usuario?.numParticipaciones || 0

    return (
        <div className={`wrapper ${className}`}>
            <div className="flex gap-4 text-center items-center justify-center">
                <span className="rounded-full border border-black px-4 py-1 m-0 font-normal text-2xl">
                    {String(numParticipaciones).padStart(2, '0')}/
                    {String(totalParticipaciones).padStart(2, '0')}
                </span>
                <span className="rpx-4 py-1 m-0 font-normal text-2xl">Sabores desbloqueados</span>
            </div>
            <Listado />
        </div>
    )
}

function Listado() {
    const { usuario } = useUsuario()
    return (
        <div className="grid grid-cols-3 gap-2 mt-8">
            {clientesFeria.map((cliente) => {
                const isActive = Boolean(
                    usuario?.participaciones?.find(
                        (participacion) =>
                            participacion.origen === 'Feria' &&
                            participacion.codigoCliente === cliente.codigo,
                    ),
                )

                // Transformar la URL del logo
                const getImageSrc = (logoUrl, active) => {
                    // Extraer el nombre del archivo sin extensión
                    const fileName = logoUrl.split('/').pop().replace('.jpg', '')

                    // Construir la nueva URL
                    const basePath = `/assets/img/slider/${TEMPORADA}/grid/`
                    const suffix = active ? '-a' : ''
                    return `${basePath}${fileName}${suffix}.jpg`
                }

                const imgSrc = getImageSrc(cliente.logo, isActive)

                return (
                    <div key={cliente.codigo} className="">
                        <img src={imgSrc} alt={cliente.nombre} />
                    </div>
                )
            })}
            <Extra />
        </div>
    )
}

function Extra() {
    const { usuario } = useUsuario()
    const isActive = usuario?.participaciones?.find(
        (p) => p.codigoCliente === participacionExtra.codigo,
    )

    const imgSrc = isActive
        ? `/assets/img/slider/${TEMPORADA}/grid/extra-a.jpg`
        : `/assets/img/slider/${TEMPORADA}/grid/extra.jpg`

    return <img src={imgSrc} alt="Extra" />
}
